import React from 'react';
import { SELLER_WEBAPP_SHARE_ROUTES } from '../../constants';
import {
  clearExtraDetails,
  dispatch,
  ProductVariant,
  updateSelectedProducts,
} from '@zonofi/zono-money-store';
import { useNavigate } from 'react-router-dom';
import './share-product-action.scss';
import { SVGS } from '../../assets';
import { ReactComponent as RightArrow } from '@zonofi/svg-icons/arrow_right.svg';

export const ShareProductAction: React.FC<{
  selectedProducts: Set<number>;
  productsData: ProductVariant[];
  showImage: boolean;
}> = ({ selectedProducts, productsData, showImage }) => {
  const navigate = useNavigate();

  return (
    selectedProducts &&
    selectedProducts?.size > 0 && (
      <div
        className="view-selected-items-button"
        onClick={() => {
          dispatch(
            updateSelectedProducts(
              productsData?.filter((i) => selectedProducts?.has(i?.id)) || []
            )
          );
          dispatch(clearExtraDetails());
          navigate(SELLER_WEBAPP_SHARE_ROUTES.VIEW_SELECTED_PRODUCTS);
        }}
      >
        {showImage && (
          <div className="view-selected-items-button-icons">
            {productsData
              ?.filter((i) => selectedProducts?.has(i?.id))
              ?.slice(0, 3)
              ?.map((i, idx) => (
                <div
                  className="view-selected-items-button-icons-icon"
                  key={i?.productVariantId}
                  style={{
                    marginLeft: idx === 0 ? 0 : '-16px',
                    zIndex: idx,
                  }}
                >
                  <img
                    src={i?.assets?.[0]?.redirectUrl || SVGS.Products}
                    alt="selected-icon"
                  />
                </div>
              ))}
          </div>
        )}
        <div className="view-selected-items-button-container">
          <span className="view-selected-items-button-container-text font-semibold">
            Share Selected
          </span>
          <span className="view-selected-items-button-container-sub-text font-semibold">{`${
            selectedProducts?.size
          } item${selectedProducts?.size > 1 ? 's' : ''}`}</span>
        </div>
        <div className="view-selected-items-button-arrow">
          <RightArrow
            color="#ffffff"
            className="view-selected-items-button-arrow-icon"
          />
        </div>
      </div>
    )
  );
};
